import { render, staticRenderFns } from "./RdbDatastoreDialog.vue?vue&type=template&id=2ddff97a&"
import script from "./RdbDatastoreDialog.vue?vue&type=script&lang=ts&"
export * from "./RdbDatastoreDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports